// extracted by mini-css-extract-plugin
export default {"center":"Row_center__b7Ych","marginHorizontal":"Row_marginHorizontal__ewq0L","header":"Row_header__HQaWz"};